import { render, staticRenderFns } from "./AnimacaoConfirmacao.vue?vue&type=template&id=498c7f3b"
import script from "./AnimacaoConfirmacao.vue?vue&type=script&lang=js"
export * from "./AnimacaoConfirmacao.vue?vue&type=script&lang=js"
import style0 from "./AnimacaoConfirmacao.vue?vue&type=style&index=0&id=498c7f3b&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports